import type { StyleProp, TextStyle, ViewStyle } from "react-native";

export type StyleObj = StyleProp<ViewStyle | TextStyle>